import React from 'react';
import { startDateModStyles } from './StartDateMod.styles';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import moment from 'moment';
import { DateRangePicker } from 'app/ComponentLibrary/DateRangeNew';
import { isNullOrUndefined } from 'app/helpers/objectHelpers';

export const NewPreEmploymentDate = ({ isModEdit }: { isModEdit: boolean }) => {
  const { classes } = startDateModStyles();
  const { control, formState: { errors }, getValues, clearErrors, setError } = useFormContext();
  const value: any = useWatch({ name: 'newPreEmploymentDate' });
  const newStartDate = 'newStartDate';

  const checkDateValidation = preEmploymentDate => {
    const newStartDateStr = getValues(newStartDate);
    if (newStartDateStr && preEmploymentDate) {
      if (moment(newStartDateStr) < moment(preEmploymentDate)) {
        return 'Must be before New Start Date';
      }
    }
    clearErrors('newPreEmploymentDate');
    return null;
  };
  return (
    <Controller
      control={control}
      name={'newPreEmploymentDate'}
      rules={{
        validate: checkDateValidation,
      }}
      render={({ field: { onChange, ...rest } }) => {
        const NewPreEmploymentDateValue = moment(value ?? null);
        return (
          <React.Fragment>
            <DateRangePicker
              onChange={newValue => {
                if (newValue.startDate !== undefined) {
                  const newDate = moment(newValue.startDate);
                  const setTo = newDate.isValid() ? moment(newDate).format('YYYY-MM-DDTHH:mm:ss') : null;

                  onChange(setTo);
                } else {
                  onChange(null);
                }
              }}
              value={value}
              onCancel={() => {}}
              clear
              open={false}
              quickSelect={false}
              variant="filled"
              single
              placeholder="New Pre Employment Date"
              useMaxWidth={true}
              labelClass={classes.inputFields}
              trailingIconShow={true}
              className={classes.inputFields}
              actionBar={false}
              clickAway={true}
              readOnly={!isModEdit}
              keepClickAwayVal={true}
              initialDateRange={{
                startDate: NewPreEmploymentDateValue.isValid()
                  ? new Date(NewPreEmploymentDateValue.format('YYYY-MM-DDTHH:mm:ss'))
                  : undefined,
                endDate: NewPreEmploymentDateValue.isValid()
                  ? new Date(NewPreEmploymentDateValue.format('YYYY-MM-DDTHH:mm:ss'))
                  : undefined,
                useLabelAsValue: true,
              }}
              onInlineEdit={val => {
                const fieldValue = val.substring(0, val.length - 1);
                if (!value && !moment(fieldValue).isValid()) {
                  setError('newPreEmploymentDate', {
                    type: 'validate',
                    message: 'Invalid Format',
                  })
                }
              }}
              error={!!errors?.newPreEmploymentDate}
              helperText={
                !isNullOrUndefined(errors?.newPreEmploymentDate) ? errors?.newPreEmploymentDate?.message : undefined
              }
            />
          </React.Fragment>
        );
      }}
    />
  );
};
